/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import Loading from './Loading/index'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/DownloadAction/Content/Content/Download/Content",
  onSubmit,
  isSubmitting
  
}) {
let downloadSubmitData = fromData.useDataSubmit({ viewPath,
context: 'download',
})
let downloadIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'download',
})
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 type="ghost"
 size="small"
 width="100%"
 data="download"
 onClick={downloadSubmitData}
 disabled={downloadIsSubmittingData}
 text="Download all"
/>
<Loading
  viewPath={`${viewPath}/Loading`}
/>
{children}
</React.Fragment>)
}